var render, staticRenderFns
import script from "./metadataMixin.vue?vue&type=script&lang=js&"
export * from "./metadataMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/metadata.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Frunner%2F_work%2FCoreWeb%2FCoreWeb%2Fmixins%2FmetadataMixin.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports